import { useUserActiveOrganization } from "@/api";
import { TypographyMuted } from "@/components/typography/Muted";
import { TypographyXS } from "@/components/typography/XS";
import { Settings } from "@/components/ui/SettingsSection";
import { CopyButton } from "@/components/ui/copyButton";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

type Props = {
  flashNewSlug: boolean;
};

const SlugRow = ({ flashNewSlug }: Props) => {
  const { activeOrganization } = useUserActiveOrganization();

  return (
    <Settings.Item
      title="Organization slug"
      description={
        <div data-testid="slugHelpText">
          A slug is a unique identifier for your organization that is
          auto-generated to match your organization&apos;s name. If you change
          the name of your organization, the slug will be automatically updated
          to match the updated name.
        </div>
      }
    >
      <div className="flex flex-col">
        <div className="grid grid-cols-[1fr_72px] gap-2 md:gap-4 items-center">
          <div className="cursor-not-allowed h-9 w-full px-3 py-1 shadow-sm min-w-36 flex flex-row items-center text-sm bg-brand-gray-50/60 dark:bg-brand-gray-800/60 border border-brand-gray-200 dark:border-brand-gray-700 rounded-md">
            <TypographyMuted className="truncate">
              <span
                data-testid="slugInput"
                className={cn(
                  "text-brand-gray-700 dark:text-brand-gray-200 animate-pulse-slug",
                  flashNewSlug ? "animate-pulse-short" : "animate-none"
                )}
              >
                {activeOrganization?.slug || ""}
              </span>
            </TypographyMuted>
          </div>

          <CopyButton
            copyText={activeOrganization?.slug || ""}
            variant="ghost"
          />
        </div>

        {flashNewSlug && (
          <motion.div
            key="slug"
            initial={{ bottom: ".5rem", opacity: 0 }}
            animate={{ bottom: 0, opacity: 1 }}
          >
            <TypographyXS
              data-testid="newSlugOldLinks"
              className="p-2 italic text-brand-gray-300 dark:text-brand-gray-400"
            >
              Earlier links to organization will not work.
            </TypographyXS>
          </motion.div>
        )}
      </div>
    </Settings.Item>
  );
};

export default SlugRow;
